import { render, staticRenderFns } from "./OnlineTestCard.vue?vue&type=template&id=3ddd81c8&functional=true"
import script from "./OnlineTestCard.vue?vue&type=script&lang=js"
export * from "./OnlineTestCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports